import {
  Component,
  Input,
} from '@angular/core';

import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'info-modal',
  templateUrl: 'info-modal.component.html',
  styleUrls: ['info-modal.component.scss'],
})
export class InfoModalComponent extends BaseModalComponent {
  @Input() title: string;
  @Input() innerHtml: string;

  public setData(title?: string, innerHtml?: string) {
    if (title) { this.title = title; }
    if (innerHtml) { this.innerHtml = innerHtml; }
  }
}
